const style = theme => ({
  base: theme.loginBase,
})

export default style
